export default __webpack_public_path__ + "static/media/eftLogo.3e8d256f.svg";